import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import app from 'modules/core/store/models/app'

import styles from './index.module.scss'

const CurrentProgress = () => {
  if (!app.progress) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.progress}>
        <Box background="viridian1000" flexDirection="row" alignItems="center" padding="s16">
          <div className={styles.spinner}>
            <Spinner size="s24" color="grey000White" />
          </div>
          <div className={styles.text}>{app.progress.message}</div>
        </Box>
      </div>
    </div>
  )
}

export default observer(CurrentProgress)
